import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Input } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { getStorage } from "../../utils/storage";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

class Unblock extends React.Component {
  state = {
    reason: "",
    unblockDonor: true,
    unblockDonation: true,
    error: {},
    isSubmitting: false,
    donationsList: [],
    selectedDonations: [],
    isLoadingDonations: false,
  };

  componentDidMount = async () => {
    if (this.props?.donor?.blockInfo?.blockReason) {
      this.setState({ reason: this.props.donor.blockInfo.blockReason });
    }
    await this.fetchBlockedDonations();
  };

  fetchBlockedDonations = async () => {
    const { donor } = this.props;
    if (!donor?._id) return;
    const user = await getStorage();
    this.setState({ isLoadingDonations: true });
    try {
      const { data } = await axios({
        method: "GET",
        url: `${API_URL}/blooddonation`,
        params: { donor: donor._id, "blockInfo.blocked": true },
        headers: { Authorization: "Bearer " + user.token },
      });
      const donations = Array.isArray(data) ? data : data?.data || [];
      this.setState({
        donationsList: donations,
        selectedDonations: donations.map((d) => d._id),
        isLoadingDonations: false,
      });
    } catch {
      this.setState({ isLoadingDonations: false });
    }
  };

  onChangeText = (field, e) => {
    let { error } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;
    delete error[field];
    this.setState({ [field]: inputValue, error });
  };

  toggleDonation = (id) => {
    const { selectedDonations } = this.state;
    const isSelected = selectedDonations.includes(id);
    this.setState({
      selectedDonations: isSelected
        ? selectedDonations.filter((d) => d !== id)
        : [...selectedDonations, id],
    });
  };

  validateForm() {
    let { error, reason, unblockDonor, unblockDonation, selectedDonations } =
      this.state;
    if (!reason) {
      error.reason = language[this.props.defaultLanguage].reason_required;
    }
    if (!unblockDonor && !unblockDonation) {
      error.unblockTarget = "Please select at least one option to unblock.";
    }
    if (unblockDonation && selectedDonations.length === 0) {
      error.selectedDonations = "Please select at least one donation to unblock.";
    }
    this.setState({ error });
  }

  unblockDonor = async (user, donor, reason) => {
    let blockInfo = { ...(donor.blockInfo || {}) };
    blockInfo.blockReason = "";
    blockInfo.unBlockReason = reason;
    blockInfo.blocked = false;

    await axios({
      method: "PUT",
      url: `${API_URL}/donor`,
      data: {
        id: donor._id,
        blockInfo,
        donorNumber: donor?.donorNumber,
        center: donor?.center?._id,
        centerSite: donor?.centerSite?._id,
        status: "pending",
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.token,
      },
    });
  };

  unblockDonations = async (user, donor, reason) => {
    const { selectedDonations, donationsList } = this.state;
    const donationsToUnblock = donationsList.filter((d) =>
      selectedDonations.includes(d._id)
    );

    for (const donation of donationsToUnblock) {
      await axios({
        method: "PUT",
        url: `${API_URL}/blooddonation`,
        data: {
          id: donation._id,
          donor: donor._id,
          donationNumber: donation._id,
          center: donor?.center?._id,
          centerSite: donor?.centerSite?._id,
          blockInfo: {
            blocked: false,
            blockReason: "",
            unblockReason: reason,
          },
          action: "unblock",
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
      });
    }
  };

  onSubmit = async () => {
    await this.validateForm();
    if (Object.keys(this.state.error).length > 0) return;

    this.setState({ isSubmitting: true });

    const { reason, unblockDonor, unblockDonation } = this.state;
    const { donor } = this.props;
    const user = await getStorage();

    try {
      if (unblockDonor) {
        await this.unblockDonor(user, donor, reason);
      }
      if (unblockDonation) {
        await this.unblockDonations(user, donor, reason);
      }

      this.setState({ isSubmitting: false });
      toastMessage(
        "success",
        language[this.props.defaultLanguage].update_data_success
      );

      if (this.props.handleCloseModal && this.props.getData) {
        this.props.getData(true);
        this.props.handleCloseModal();
      }
    } catch (err) {
      toastMessage("error", language[this.props.defaultLanguage].error_update_data);
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const lang = language[this.props.defaultLanguage];
    const {
      unblockDonor,
      unblockDonation,
      reason,
      error,
      isSubmitting,
      donationsList,
      selectedDonations,
      isLoadingDonations,
    } = this.state;

    return (
      <div>
        <div className="card-body" style={{ padding: "0.75rem 1rem" }}>
          <div className="row">
            <div className="col-md-12" style={{ marginBottom: 10 }}>
              <p
                className="text-bold"
                style={{
                  fontSize: "var(--font-size-sm, 13px)",
                  marginBottom: 6,
                }}
              >
                {lang.unblock_target}
              </p>
              <label
                className="d-flex align-items-center gap-2"
                style={{
                  marginBottom: 5,
                  cursor: "pointer",
                  fontSize: "var(--font-size-sm, 13px)",
                }}
              >
                <input
                  type="checkbox"
                  checked={unblockDonor}
                  onChange={() =>
                    this.setState((s) => ({
                      unblockDonor: !s.unblockDonor,
                      error: {},
                    }))
                  }
                  style={{ accentColor: "var(--primary-color)" }}
                />
                {lang.unblock_donor}
              </label>
              <label
                className="d-flex align-items-center gap-2"
                style={{
                  marginBottom: 4,
                  cursor: "pointer",
                  fontSize: "var(--font-size-sm, 13px)",
                }}
              >
                <input
                  type="checkbox"
                  checked={unblockDonation}
                  onChange={() => {
                    const next = !this.state.unblockDonation;
                    this.setState({ unblockDonation: next, error: {} });
                    if (next && donationsList.length === 0) {
                      this.fetchBlockedDonations();
                    }
                  }}
                  style={{ accentColor: "var(--primary-color)" }}
                />
                {lang.unblock_donation}
              </label>

              {/* Blocked donations list */}
              {unblockDonation && (
                <div
                  style={{
                    marginLeft: 20,
                    marginTop: 6,
                    maxHeight: 180,
                    overflowY: "auto",
                    border: "1px solid var(--text-color-10, #e0e0e0)",
                    borderRadius: 6,
                    padding: "6px 8px",
                    background: "var(--light-color, #fafafa)",
                  }}
                >
                  {isLoadingDonations ? (
                    <small className="text-muted">Loading donations…</small>
                  ) : donationsList.length === 0 ? (
                    <small className="text-muted">No blocked donations found.</small>
                  ) : (
                    <>
                      {donationsList.map((donation) => (
                        <label
                          key={donation._id}
                          className="d-flex align-items-center gap-2"
                          style={{
                            marginBottom: 4,
                            cursor: "pointer",
                            fontSize: "0.78rem",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedDonations.includes(donation._id)}
                            onChange={() => this.toggleDonation(donation._id)}
                            style={{ accentColor: "var(--primary-color)" }}
                          />
                          <span style={{ fontWeight: 600 }}>
                            {donation.donationNumber || donation._id}
                          </span>
                          {donation.createdAt && (
                            <span className="text-muted">
                              {moment(donation.createdAt).format("ll")}
                            </span>
                          )}
                        </label>
                      ))}
                    </>
                  )}
                </div>
              )}
              {error.selectedDonations && (
                <small className="text-danger d-block mt-1">
                  {error.selectedDonations}
                </small>
              )}
              {error.unblockTarget && (
                <small className="text-danger d-block mt-1">
                  {error.unblockTarget}
                </small>
              )}
            </div>
            <div className="col-md-12">
              <Input
                placeholder={lang.reason_placeholder}
                label={lang.reason}
                required
                value={reason}
                onChange={(e) => this.onChangeText("reason", e)}
                error={error.reason}
                textarea
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={lang.cancel}
            onPress={this.props.handleCloseModal}
            className="btn-default"
          />
          <Button
            text={lang.submit}
            onPress={this.onSubmit.bind(this)}
            isSubmitting={isSubmitting}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return { defaultLanguage };
};

export default connect(mapStateToProps)(Unblock);
